import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { conversationalWorkflow } from "./constants";
import type { ConversationalWorkflowResult } from "./types";
import { isConversationalWorkflowResult } from "./validators";

export const getConversationalWorkflow = reactQueryFetcherAdapter(
  conversationalWorkflow,
  (signal: AbortSignal, appGroupId: string, workflowId: string): Promise<ConversationalWorkflowResult> => {
    return fetch(`/${appGroupId}/conversational/workflow/${workflowId}`, "GET", {}, { signal });
  },
  isConversationalWorkflowResult
);
